import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { api } from "../lib/api";
import { useT } from "../i18n/LanguageContext";

export default function WhatsAppFloat() {
    const { t } = useT();
    const [phone, setPhone] = useState("+13055551234");

    useEffect(() => {
        api.get("/config")
            .then((r) => {
                if (r.data?.whatsapp_number) setPhone(r.data.whatsapp_number);
            })
            .catch(() => {});
    }, []);

    const clean = phone.replace(/[^+\d]/g, "").replace(/^\+/, "");
    const text = encodeURIComponent(t("wa.prefill"));
    const url = `https://wa.me/${clean}?text=${text}`;

    return (
        <motion.a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 1.5, type: "spring", stiffness: 120 }}
            className="fixed bottom-6 right-6 z-40 group"
            data-testid="whatsapp-float-btn"
            aria-label="Contact on WhatsApp"
        >
            <span className="absolute inset-0 rounded-full bg-[#25D366]/40 blur-xl scale-125 group-hover:scale-150 transition-transform" />
            <span className="relative flex items-center gap-3 bg-[#25D366] text-white px-5 py-4 rounded-full shadow-xl hover:bg-[#1ebf5a] transition-colors">
                <MessageCircle size={20} strokeWidth={2} />
                <span className="hidden sm:inline text-xs tracking-[0.2em] uppercase font-semibold">
                    {t("wa.label")}
                </span>
            </span>
        </motion.a>
    );
}
